import {actions as A} from '../constants/actions';

const defaultState = {
  nextStep: null,
  currentUserStepNumber: 0,
  totalSteps: 0,
  goBack: false,
  desktopCompletedStages: [],
  loading: false,
  error: false,
  errorMessage: null
};

export default (state = defaultState, {type, payload}) => {
  switch(type) {
    case A.GET_SPECIFIC_STEP:
      return {...state, loading: true};

    case A.GET_SPECIFIC_STEP_SUCCESS:
      return {...state, loading: false, ...payload};

    case A.GET_SPECIFIC_STEP_FAILURE:
      const {errorMessage} = payload;
      return {...state, loading: false, error: true, errorMessage};

    case A.SET_SPECIFIC_STEP:
      const {step} = payload;
      return {...state, nextStep: step, currentUserStepNumber: step};

    default:
      return state;
  }
}
